import { useDispatch, useSelector } from 'react-redux'
import { isLoggedIn, getIdentityUser, getIdentityProfile } from 'identity/selectors'
import { loginRequest, logoutRequest } from 'quick-quote/actions'
import LoginDropdown from './login-dropdown'

export const LoginLink = (props) => {
  const { icon } = props
  const dispatch = useDispatch()
  const isLoggedInState = useSelector(isLoggedIn)
  const user = useSelector(getIdentityUser)
  const profile = useSelector(getIdentityProfile)

  const handleLoginRequest = (e) => {
    dispatch(loginRequest())
    e.preventDefault()
  }

  const handleLogoutRequest = () => {
    dispatch(logoutRequest())
  }

  if (isLoggedInState && user.type === 'Authenticated') {
    return <LoginDropdown icon={icon} user={user} logoutRequest={handleLogoutRequest} />
  } else {
    return (
      <a onClick={handleLoginRequest}>
        <span id={icon} className="global-nav-link"></span>
      </a>
    )
  }
}
